import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {BlockTemplateComponent} from 'src/app/components/block-template/block-template/block-template.component';

@Component({
  selector: 'proposta-externa-layout',
  templateUrl: './proposta-externa-layout.component.html',
  // styleUrls: ['./auth-layout.component.scss']
})
export class PropostaExternaLayoutComponent implements OnInit, OnDestroy {
  test: Date = new Date();
  public isCollapsed = true;
  mensagemSpinner$ = this._spinnerService.mensagem$;
  constructor(
    private router: Router,
    private _spinnerService: SpinnerService,
  ) {}

  blockTemplate: BlockTemplateComponent | undefined;

  ngOnInit() {}

  ngOnDestroy() {}
}
